export const findGuestByUserId = (guests, userId) => (
  guests.find((guest) => guest.user_id === userId) || null
);
